import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RemoveLoaderService } from '../service/remove-loader.service'

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

	isLoaderActive: boolean;
  public loaderGif: string;
  public merchant: string;


  constructor(
  	private removeLoaderService: RemoveLoaderService,
  ){ 
    let _ = this;

  }

  ngOnInit() {
    this.getMerchant();
    this.gifMapping();
  }

  updateLoaderActive(){
    let _ = this;
  }

  private getMerchant(): void {
    this.merchant = location.href.split("/")[3];
  }

  private gifMapping(): void {
    this.loaderGif = this.merchant === 'eolympics' ? '/assets/images/loader_so.gif' : '/assets/images/loader.gif';
  }

}
